import React, { useState } from "react";
import { Button, Col, Container, Row, Card, Modal, Form, InputGroup } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import "./css/infistaking.css"; // Ensure this CSS file exists and the classes are correct
import BotModal from "../MainModal/botModal";

export default function Tokenization() {
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const navigate = useNavigate();

  const infiApplicationForm = () => {
    navigate(`${config.baseUrl}infiListingForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="infiLaunchpad position-relative pt-0 pb-0 overflow-hidden">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <Card className="bg-transparent border-0">
                <Card.Body>
                  <div className="position-relative mb-5">
                    <div className="position-relative d-inline-block text-left">
                      <h1 className=" position-relative text-white lh-sm mb-4">
                        <span className="position-relative z-1">
                          ©SbSe Protocol
                          <span className="fw-normal">
                            – Powering the Next Era of Decentralised Digital Innovation.
                          </span>
                        </span>
                        <div
                          className="polygon"
                          style={{ right: "0px" }}
                        >
                          <img
                            src="images/shape/polygon.png"
                            alt=""
                            style={{ width: "208px" }}
                          />
                        </div>
                      </h1>
                      <p className="text-light-grey2 position-relative">
                        SbSe Protocol is a next-generation blockchain framework designed to integrate
                        intelligent automation, cross-chain operability, and decentralised infrastructure into a
                        unified, secure, and scalable ecosystem.
                      </p>
                    </div>

                    <div>
                      <ul className="ps-0 list-unstyled mb-4">
                        <li className="mb-3 text-light-grey2">
                          🔹 Decentralised Engagement Tools - Supports user participation through
                          configurable, non-minting reward and utility models.
                        </li>
                        <li className="mb-3 text-light-grey2">
                          🔹 Digital Asset Representation - Streamlines the creation of blockchain-based
                          references for various off-chain elements, including physical items or data sets, enabling
                          broader use-case integration.
                        </li>
                        <li className="mb-3 text-light-grey2">
                          🔹 AI-Driven Intelligence – Incorporates artificial intelligence for pattern recognition,
                          dynamic insights, and automated logic execution within decentralised environments.
                        </li>
                        <li className="mb-3 text-light-grey2">
                          🔹 On-Chain Risk Monitoring – Implements blockchain-native mechanisms to identify
                          irregular activity patterns and enhance network integrity, with privacy-aware safeguards.
                        </li>
                        <li className="mb-3 text-light-grey2">
                          🔹 Cross-Chain Architecture – Built for seamless interaction across major blockchain
                          protocols, promoting interoperability and scalability.
                        </li>
                        <li className="mb-3 text-light-grey2">
                          🔹 Creator Ecosystem for Digital Projects - A flexible environment for blockchainbased initiatives to gain visibility, form collaborations, and activate use-case-driven token
                          deployments.
                        </li>
                      </ul>
                      <Button
                        variant="white-gradient"
                        className="me-3 px-5 rounded-5 text-uppercase"
                      >
                        MARKET PLACE (soon)&nbsp;&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.7921 1.08813L22.6729 9.21992M22.6729 9.21992L15.7921 17.3517M22.6729 9.21992L1.3269 9.21992"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      {/* ---------- */}
      {/* <BotModal show={show} onHide={handleClose}/> */}
    </>
  );
}